import {format, isWithinInterval, set} from 'date-fns';
import {PtrnCampoEditableTime, PtrnCampoValidarResult} from '../../patronTypes';
import {FORMATS} from '../../constants';
import {PtrnValidarCampoFn} from './ptrnProcesarTypes';
import {PtrnProcesarUtilsCfg} from './ptrnProcesarUtils';
import {ValidateState} from 'lib.common';

export const ptrnValidacionTime: PtrnValidarCampoFn<Date | null, PtrnCampoEditableTime> = (
   newValue,
   campoConfig,
   estado
) => {
   const validateResult: PtrnCampoValidarResult = PtrnProcesarUtilsCfg.NoErrResult();
   //1. control de errores q deben evitar actualizacion del estado, x ejemplo si es numerico no deberia actualizar si el nuevo valor contiene letras o si excede los caracteres configurados
   //|---> si existe error hacer result.push(<mensaje_error>) y retornar resultconst date = new Date();
   if (campoConfig.minutesStep) {
      const minutesFromMidnight = (newValue?.getHours() || 0) * 60 + (newValue?.getMinutes() || 0);
      if (minutesFromMidnight % campoConfig.minutesStep !== 0) {
         validateResult.errores.push(
            PtrnProcesarUtilsCfg.ErrValidar(
               `El tiempo debe ser múltiplo de ${campoConfig.minutesStep} minutos.`
            )
         );
         validateResult.gravedadMaxima = ValidateState.ERROR;
         return validateResult;
      }
   }
   const baseDate = new Date(2000, 0, 1); // Fecha base arbitraria
   const timeToCheck = set(baseDate, {
      hours: newValue?.getHours() || 0,
      minutes: newValue?.getMinutes() || 0,
      seconds: newValue?.getSeconds() || 0
   });

   // Validación de rango de tiempo (maxTime y minTime)
   if (campoConfig.maxTime && campoConfig.minTime) {
      const maxTime = set(baseDate, {
         hours: campoConfig.maxTime.getHours(),
         minutes: campoConfig.maxTime.getMinutes(),
         seconds: campoConfig.maxTime.getSeconds()
      });

      const minTime = set(baseDate, {
         hours: campoConfig.minTime.getHours(),
         minutes: campoConfig.minTime.getMinutes(),
         seconds: campoConfig.minTime.getSeconds()
      });

      if (!isWithinInterval(timeToCheck, {start: minTime, end: maxTime})) {
         validateResult.errores.push(
            PtrnProcesarUtilsCfg.ErrValidar(
               `El tiempo debe estar entre ${format(minTime, FORMATS.time)} y ${format(
                  maxTime,
                  'HH:mm:ss'
               )}`
            )
         );
         validateResult.gravedadMaxima = ValidateState.ERROR;
         return validateResult;
      }
   } else {
      if (campoConfig.maxTime) {
         const maxTime = set(baseDate, {
            hours: campoConfig.maxTime.getHours(),
            minutes: campoConfig.maxTime.getMinutes(),
            seconds: campoConfig.maxTime.getSeconds()
         });

         if (timeToCheck > maxTime) {
            validateResult.errores.push(
               PtrnProcesarUtilsCfg.ErrValidar(
                  `El tiempo no puede ser posterior a ${format(maxTime, FORMATS.time)}`
               )
            );
            validateResult.gravedadMaxima = ValidateState.ERROR;
            return validateResult;
         }
      }

      if (campoConfig.minTime) {
         const minTime = set(baseDate, {
            hours: campoConfig.minTime.getHours(),
            minutes: campoConfig.minTime.getMinutes(),
            seconds: campoConfig.minTime.getSeconds()
         });

         if (timeToCheck < minTime) {
            validateResult.errores.push(
               PtrnProcesarUtilsCfg.ErrValidar(
                  `El tiempo no puede ser anterior a ${format(minTime, FORMATS.time)}`
               )
            );
            validateResult.gravedadMaxima = ValidateState.ERROR;
            return validateResult;
         }
      }
   }

   return validateResult;
};
